export * from './lib/edf-appliances-feature-shell.module';
